module.exports = __webpack_public_path__ + "media/application/images/ui/purchase/consumer-join-x-a39951fa02bb98cf8184a3fd46b2e0a1.jpg";